import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const DashboardPage = lazy(() => import('./DashboardPage'));

export const dashboardRoutes: RouteObject[] = [
  {
    path: 'dashboard',
    element: (
      <ProtectedRoute action="dashboard:view">
        <DashboardPage />
      </ProtectedRoute>
    ),
  },
];
